module.exports = __webpack_public_path__ + "c1f1e2ab403840ee075fb85e816ce30d.MP3";